import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
// import setRemInit from './plugins/setRem' ///rem
import router from './router/index'
Vue.config.productionTip = false
Vue.use(ElementUI);
// setRemInit()
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
